<template>
	<div>
		<Card>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">充值方式手续费费率列表</span>
					</div>
					<div class="right-bar">

					</div>
				</div>
				</Col>
			</Row>

			<Row :gutter="16">
				<Col span="24">
				<Table :columns="mainTable.columns" :data="mainTable.data" :loading="mainTable.loading" border/>
				</Col>
			</Row>
		</Card>
		<Modal v-model="rechargeFeeRateForm.show" title="编辑充值手续费费率" width="600">
			<Spin v-if="innerSpin"
			     size="large"
			     fix></Spin>
			<Form ref="rechargeFeeRateForm" :model="rechargeFeeRateForm" label-position="top">
				<Row :gutter="16">
					<Col span="12">
					<FormItem label="充值方式">
						<Input v-model="rechargeFeeRateForm.bandServiceFeeRatePaidType" readonly></Input>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="手续费费率(%)">
						<InputNumber v-model="rechargeFeeRateForm.bandServiceFeeRateValue" :min="0" :step="0.01"
							:active-change="false" style="width:100%"></InputNumber>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="onSave">确认</Button>
				<Button type="error" @click="onCancel">取消</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
import search from "@/libs/search";
import {
    dateTimeRender
} from '@/libs/tableRowTimeRender';
import {
    formatPayType,
    getPayTypeOptions,
    PAY_TYPE_MANUAL
} from '../bank-record/BankRecordStatus';
import {
    getBandServiceFeeRateList,
    saveBandServiceFeeRate
} from '@/api/modules/finance-management/recharge-fee-rate';
export default {
    name: "RechargeFeeRateList",
    components: {},
    data() {
        return {
            mainTable: {
                columns: [{
                    title: "充值方式",
                    key: "bandServiceFeeRatePaidType",
                    align: "center",
                    render: (h, params) => {
                        return h('div', [
                            h('span', {}, formatPayType(params.row.bandServiceFeeRatePaidType))
                        ]);
                    }
                },
                {
                    title: "手续费费率(%)",
                    key: "bandServiceFeeRateValue",
                    align: "center"
                },
                {
                    title: "修改时间",
                    key: "modifyTime",
                    align: "center",
                    render: (h, params) => dateTimeRender(h, params.row.modifyTime)
                },
                {
                    title: "修改人账号",
                    key: "userName",
                    align: "center"
                },
                {
                    title: "修改人姓名",
                    key: "userPersonName",
                    align: "center"
                },
                {
                    title: "修改人手机号",
                    key: "userPhone",
                    align: "center"
                },
                {
                    title: '操作',
                    key: 'action',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style: {
										    visibility: this.$checkAccessArray(['I']) ? 'visible' : 'hidden'
                                },
                                on: {
                                    click: () => {
                                        this.onRateUpdate(params.row);
                                    }
                                }
                            }, '编辑')
                        ]);
                    }
                }
                ],
                data: [],
                loading: false
            },
            rechargeFeeRateForm: {
                show: false,
                bandServiceFeeRateUuid: '',
                bandServiceFeeRatePaidType: '',
                bandServiceFeeRateValue: 0
            },
            innerSpin: false
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getRechargeFeeRateList();
        },
        //获取充值方式手续费费率列表
        getRechargeFeeRateList() {
            const mainTableSearch = search.getSearchParams({
                closeAllConditions: true
            });
            this.mainTable.loading = true;
            getBandServiceFeeRateList(mainTableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                }
            });
        },
        //编辑费率
        onRateUpdate(row) {
            this.rechargeFeeRateForm.show = true;
            this.rechargeFeeRateForm.bandServiceFeeRateUuid = row.bandServiceFeeRateUuid;
            this.rechargeFeeRateForm.bandServiceFeeRatePaidType = formatPayType(row.bandServiceFeeRatePaidType);
            this.rechargeFeeRateForm.bandServiceFeeRateValue = row.bandServiceFeeRateValue;
        },
        //保存编辑
        onSave() {
            let data={
                bandServiceFeeRateUuid:this.rechargeFeeRateForm.bandServiceFeeRateUuid,
                bandServiceFeeRateValue:this.rechargeFeeRateForm.bandServiceFeeRateValue
            };
            this.innerSpin = true;
            saveBandServiceFeeRate(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
						 this.$Message.success('保存成功!');
						 this.rechargeFeeRateForm.show = false;
						 this.getRechargeFeeRateList();
                }
            });
				
        },
        //取消编辑
        onCancel() {
            this.rechargeFeeRateForm.show = false;
        }
    }
};
</script>

<style scoped></style>